export default __webpack_public_path__ + "static/media/chatBg2.48564961.png";